// extracted by mini-css-extract-plugin
export default {"wrapper":"OpenApiDocumentation_wrapper__u3qVG"};